export const DEEPLINK_SCHEME = 'teachtap';
